const productsGrid = document.getElementById("products-grid");

if (productsGrid && typeof ajax_lazy_load_params !== "undefined") {
  let currentPage = 1;
  let loading = false;
  let hasMore = true;

  // Get current filter values from URL
  const urlParams = new URLSearchParams(window.location.search);
  const currentFilters = {
    min_price: urlParams.get("min_price"),
    max_price: urlParams.get("max_price"),
    sort: urlParams.get("sort"),
    search:
      urlParams.get("search") ||
      (window.wp_vars && window.wp_vars.search_params
        ? window.wp_vars.search_params.search
        : ""),
  };

  const loadMoreProducts = () => {
    if (loading || !hasMore) return;
    loading = true;
    currentPage += 1;

    // Create loading indicator
    const loadingIndicator = document.createElement("div");
    loadingIndicator.className = "products-loading";
    loadingIndicator.innerHTML = '<div class="spinner"></div>';
    productsGrid.parentNode.appendChild(loadingIndicator);

    const formData = new URLSearchParams({
      action: "load_more_products",
      nonce: ajax_lazy_load_params.nonce,
      page: currentPage,
    });

    // Add filter parameters if they exist
    if (currentFilters.min_price) {
      formData.append("min_price", currentFilters.min_price);
    }
    if (currentFilters.max_price) {
      formData.append("max_price", currentFilters.max_price);
    }
    if (currentFilters.sort) {
      formData.append("sort", currentFilters.sort);
    }

    // Add search parameter if it exists
    if (currentFilters.search) {
      formData.append("search", currentFilters.search);
    }

    // Add category if it exists
    if (ajax_lazy_load_params.category_id > 0) {
      formData.append("category_id", ajax_lazy_load_params.category_id);
    }

    fetch(ajax_lazy_load_params.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        loading = false;

        // Remove loading indicator
        const loadingIndicator = document.querySelector(".products-loading");
        if (loadingIndicator) {
          loadingIndicator.remove();
        }

        if (!data.success) {
          hasMore = false;
          window.removeEventListener("scroll", handleScroll);
          return;
        }

        if (data.data.html) {
          productsGrid.insertAdjacentHTML("beforeend", data.data.html);
          hasMore = data.data.hasMore;

          // Dispatch custom event for new content
          const event = new CustomEvent("productsLazyLoaded", {
            detail: {
              container: productsGrid,
              foundPosts: data.data.foundPosts,
              page: currentPage,
              totalPages: data.data.totalPages,
            },
          });
          document.dispatchEvent(event);

          if (!hasMore) {
            window.removeEventListener("scroll", handleScroll);
          }
        }
      })
      .catch((error) => {
        console.error("Error loading more products:", error);
        loading = false;

        // Remove loading indicator on error
        const loadingIndicator = document.querySelector(".products-loading");
        if (loadingIndicator) {
          loadingIndicator.remove();
        }
      });
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const threshold = document.documentElement.scrollHeight * 0.8;

    if (scrollPosition >= threshold) {
      loadMoreProducts();
    }
  };

  // Add a small delay before adding scroll listener to prevent immediate loading
  setTimeout(() => {
    // Only add scroll listener if there might be more products
    if (productsGrid.children.length > 0) {
      window.addEventListener("scroll", handleScroll);
    }
  }, 100);
}
